const TZ = 'Europe/Istanbul';

export function formatPurchaseDateTime(value) {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{2}\.\d{2}\.\d{4} \d{2}:\d{2}/.test(value.trim())) {
    return value.trim();
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return typeof value === 'string' ? value : '';

  const parts = new Intl.DateTimeFormat('tr-TR', {
    timeZone: TZ,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  }).formatToParts(date);
  const pick = (type) => parts.find((part) => part.type === type)?.value || '';
  let hour = pick('hour');
  if (hour === '24') hour = '00';
  return `${pick('day')}.${pick('month')}.${pick('year')} ${hour}:${pick('minute')}`;
}
